<div class="vertical_stepper">
  <ul class="web_stepper">
    <!-- i!=steps.length-1 -->
    <li class="vertical_steps"
      [ngClass]="{'progress_bar': i!=steps.length-1 , 'completed' : step.isCompleted ? step.isCompleted : step.subSteps.length > 0 ? step.subSteps.isCompleted :  step.isCompleted}"
      *ngFor="let step of steps; let i = index;" (click)="goToStep(step)">
      <div class="number">{{step.index}}</div>
      <p class="step_label">{{step.step}} 
        <img *ngIf="i==0 && step.subSteps.length!=0" (click)="toggleButton()"
          src="../../../assets/icons/down_arrow_black.svg" alt=""></p>
      <ul *ngIf="step.subSteps.length!=0 && isBasicHomeExpanded!=false"> 
        <li class="vertical_sub_step" (click)="goToSubStep(subStep)"
          [ngClass]="{'active': currentIndex==subStep.index,'completed':subStep.isCompleted}"
          *ngFor="let subStep of step.subSteps; let j = index;">
          {{subStep.step}}
          <!-- {{subStep.index}} -->
        </li>
      </ul>
    </li>
  </ul>
  <div class="mobile">

    <div class="d_flex justify_space_bt " (click)="mobileToggle()">
      <p class="listing_text">View Listing Steps and Progress</p>
      <i class="fa-solid fa-chevron-down arrow_down"></i>
    </div>
    <ul class="mobile_stepper" *ngIf="isMobileStepperExpanded">
      <li class="vertical_steps "
        [ngClass]="{'progress_bar': i!=steps.length-1, 'completed' : step.isCompleted ? step.isCompleted : step.subSteps.length > 0 ? step.subSteps.isCompleted :  step.isCompleted}"
        *ngFor="let step of steps; let i = index;" (click)="goToStep(step)">
        <div class="number">{{step.index}}</div>
        <p class="step_label">{{step.step}} <img *ngIf="i==0 && step.subSteps.length!=0" (click)="toggleButton()"
            src="../../../assets/icons/down_arrow_black.svg" alt=""></p>
        <ul *ngIf="step.subSteps.length!=0 &&isBasicHomeExpanded!=false">
          <li class="vertical_sub_step" (click)="goToSubStep(subStep)"
            [ngClass]="{'active': currentIndex==subStep.index,'completed':subStep.isCompleted}"
            *ngFor="let subStep of step.subSteps; let j = index;">
            {{subStep.step}}
            <!-- {{subStep.index}} -->
          </li>
        </ul>
      </li>
    </ul>
  </div>
</div>